import { action, observable, reaction } from 'mobx'
import { POSStore } from './POSStore'
import { GlobalStore } from './GlobalStore'

export class AgeVerificationStore {
  @observable shouldDisplayAgeVerificationModal = false
  @observable showAgeVerificationWarning = false

  constructor(private posStore: POSStore) {
    this.reactToPaymentLines()
  }

  reactToPaymentLines() {
    reaction(
      () => ({
        paymentLines: this.posStore.currentPayment?.paymentLines || [],
        maxAgeRequirement: this.maxAgeRequirement,
      }),
      ({ paymentLines, maxAgeRequirement }) => {
        if (paymentLines.length === 0 || maxAgeRequirement === undefined) {
          this.setShowAgeVerificationWarning(false)
        }
      },
    )
  }

  @action
  setShouldDisplayAgeVerificationModal = (display: boolean) => {
    this.shouldDisplayAgeVerificationModal = display
  }

  @action
  setShowAgeVerificationWarning = (showAgeVerificationWarning: boolean) => {
    this.showAgeVerificationWarning = showAgeVerificationWarning
  }

  get maxAgeRequirement(): undefined | number {
    if (GlobalStore.isGreenlineApp || !this.posStore.currentPayment) {
      return
    }

    let maxAgeRequirement: number | undefined = undefined

    this.posStore.currentPayment.paymentLines.forEach((line) => {
      const category = this.posStore.productStore.categories?.find((category) => {
        const categoryIdToCheck = line.parentCategoryId ?? line.categoryId

        return category.id === categoryIdToCheck
      })

      if (!category || category.defaultMinimumAge === null) {
        return
      }

      if (!maxAgeRequirement || category.defaultMinimumAge > maxAgeRequirement) {
        maxAgeRequirement = category.defaultMinimumAge
      }
    })

    return maxAgeRequirement
  }
}
